var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1200pt",
    height: "1200pt",
    viewBox: "0 0 1200 1200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m36.609 695.95v-191.81c0-15.938 12.984-28.875 28.875-28.875h409.78v-409.78c0-15.891 12.938-28.875 28.875-28.875h191.81c15.891 0 28.875 12.984 28.875 28.875v409.78h409.69c15.891 0 28.875 12.938 28.875 28.875v191.81c0 15.891-12.984 28.875-28.875 28.875h-409.69v409.69c0 15.891-12.984 28.875-28.875 28.875h-191.81c-15.938 0-28.875-12.984-28.875-28.875v-409.69h-409.78c-15.891 0-28.875-12.984-28.875-28.875zm57.75-162.98v134.11h409.78c15.891 0 28.828 12.938 28.828 28.875v409.69h134.11v-409.69c0-15.938 12.938-28.875 28.875-28.875h409.69v-134.11h-409.69c-15.938 0-28.875-12.938-28.875-28.828v-409.78h-134.11v409.78c0 15.891-12.938 28.828-28.828 28.828z ",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/PlusWhite.fc6ff75e2600f5aeb32786c865662727.svg";
export { ForwardRef as ReactComponent };